import { Circle, Clock, CheckCircle2, XCircle } from "lucide-react";
import { Badge } from "../ui/badge";
import type { BadgeProps } from "../ui/badge";
import type { IdentityVerificationStatus } from "../../api/identityVerification";

const STATUS_CONFIG: Record<
  IdentityVerificationStatus,
  { label: string; icon: typeof Circle; variant: NonNullable<BadgeProps["variant"]> }
> = {
  non_soumis: { label: "Non démarrée", icon: Circle, variant: "outline" },
  en_attente: { label: "En cours de vérification", icon: Clock, variant: "warning" },
  validee: { label: "Identité vérifiée", icon: CheckCircle2, variant: "soft" },
  rejetee: { label: "Documents à renvoyer", icon: XCircle, variant: "destructive" },
};

export default function StatusBadge({ status }: { status: IdentityVerificationStatus }) {
  const cfg = STATUS_CONFIG[status] ?? STATUS_CONFIG.non_soumis;
  const Icon = cfg.icon;
  return (
    <Badge variant={cfg.variant}>
      <Icon aria-hidden size={14} className="mr-1" />
      {cfg.label}
    </Badge>
  );
}
